const APP_TOKEN_KEY = "opero_token";
const APP_REFRESH_KEY = "opero_refresh_token";

export const tokenStorage = {
  getToken: () => localStorage.getItem(APP_TOKEN_KEY),
  setToken: (token: string) => localStorage.setItem(APP_TOKEN_KEY, token),
  getRefreshToken: () => localStorage.getItem(APP_REFRESH_KEY),
  setRefreshToken: (token: string) =>
    localStorage.setItem(APP_REFRESH_KEY, token),
  clearTokens: () => {
    localStorage.removeItem(APP_TOKEN_KEY);
    localStorage.removeItem(APP_REFRESH_KEY);
  },
} as const;

export { APP_TOKEN_KEY, APP_REFRESH_KEY };
